import URI from 'urijs'
import $ from 'cash-dom'
import _ from 'lodash'
import Handlebars from 'handlebars'
import imagesLoaded from 'imagesloaded'
import Masonry from 'masonry-layout'
import {Fancybox} from '@fancyapps/ui'
import '@fancyapps/ui/dist/fancybox/fancybox.css'
import data from './data.js'
import 'normalize.css'

const type = new URI().fragment()
const template1 = Handlebars.compile($('#template1').html())
$('body').append(template1(data.extra[type]))
const template2 = Handlebars.compile($('#template2').html())
$('body').append(template2(_.pickBy(data, function(v, k) {
  return _.startsWith(k, type)
})))

$('.m-h1').on('click', '.to-home-btn', function() {
  location.href = 'index.html'
})

const masonry1 = new Masonry('#wall1', {
  itemSelector: '#wall1 .m-wall-brick',
  columnWidth: '#wall1 .m-wall-sizer',
  gutter: '#wall1 .m-wall-gutter-sizer',
  percentPosition: true
})
imagesLoaded('#wall1').on('progress', function() {
  masonry1.layout()
})

$('#wall1').on('click', '.m-image', function(e) {
  new Fancybox([
    {
      src: 'collection.html#' + $(e.target).data('id'),
      type: 'iframe'
    }
  ], {
    Html: {
      autoSize: false
    }
  })
})
